module.exports = __webpack_public_path__ + "static/media/d12.16d921cb.jpg";